<template>
 <div class="app-container">
    <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="120px" size="mini">
        <div class="formItemBox">
            <el-form-item label="转货单号:" prop="changeNo">
              <el-input  placeholder="" v-model="searchFrom.changeNo"></el-input>
            </el-form-item>
              <el-form-item label="所在仓库:" prop="organizationId">
                <el-select  v-model="searchFrom.organizationId"  placeholder="">
                  <el-option v-for="val in warehouseList" :label="val.relTenantName" :value="val.relTenantCode" :key="val.relTenantCode"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="新客户名称:" prop="newCustomerName">
                <el-input  placeholder="" maxlength="40" v-model="searchFrom.newCustomerName"></el-input>
              </el-form-item>
              <!-- <el-form-item label="新客户联系人:" prop="newCustomerContacts">
                <el-input  placeholder="" maxlength="10" v-model="searchFrom.newCustomerContacts"></el-input>
              </el-form-item>
              <el-form-item label="新客户联系电话:" prop="newCustomerPhone">
                <el-input  placeholder="" maxlength="11" v-model="searchFrom.newCustomerPhone"></el-input>
              </el-form-item> -->
            <el-form-item label="转货状态 :" prop="status">
              <el-select v-model="searchFrom.status" placeholder="请选择">
                <el-option  label="请选择" value="" ></el-option>
                <el-option  label="待提交" value="1001" ></el-option>
                <el-option  label="审批中" value="1011" ></el-option>
                <el-option  label="审批驳回" value="1012" ></el-option>
                <el-option  label="转货中" value="1021" ></el-option>
                <el-option  label="已完成" value="1031" ></el-option>
                <el-option  label="已退回" value="1041" ></el-option>
              </el-select>
            </el-form-item>
               <el-form-item label="创建时间:" prop="createTime">
                    <el-date-picker
                      v-model="searchFrom.createTime"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      type="daterange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                    ></el-date-picker>
                  </el-form-item>
                  <el-form-item label="转货完成时间:" prop="completeTime">
                    <el-date-picker
                      v-model="searchFrom.completeTime"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      type="daterange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                    ></el-date-picker>
                  </el-form-item>
        </div>

       <div class="searchBtnBox">
         <el-form-item btnCode="004P002B000"  v-if="btnFlg[0]">
            <el-button type="primary" @click="searchFn">查询</el-button>
          </el-form-item>
          <el-form-item btnCode="004P002B001"  v-if="btnFlg[1]">
            <el-button type="primary" @click="resetForm('searchFrom')">重置</el-button>
          </el-form-item>
          <!-- <el-form-item>
            <el-button type="primary" @click="submitFn">提交</el-button>
          </el-form-item> -->
       </div>
      </el-form>
    </div>
    <!-- 表格 -->
    <div :style="{height:h}">
        <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick" class="tableComent" height="100%" style="width: 100%" center :row-key="getRowKeys" border  >
        <!-- <el-table-column type="selection" width="30" :reserve-selection="true"></el-table-column> -->
        <el-table-column fixed type="index"  width="55" label="序号"></el-table-column>
        <el-table-column label="操作"  width="156">
            <template slot-scope="scope">
              <div>
              <el-button type="text" size="mini" btnCode="004P002B002"  v-if="btnFlg[2]" v-show="scope.row.status==1001" @click="modifyFn(scope.row)">编辑</el-button>
              <el-button type="text" size="mini" btnCode="004P002B003"  v-if="btnFlg[3]" v-show="scope.row.status==1001||scope.row.status==1012" @click="recallFn(scope.row)">删除</el-button>
              <el-button type="text" size="mini" btnCode="004P002B004"  v-if="btnFlg[4]" v-show="scope.row.status==1001" @click="submitFn(scope.row)">提交</el-button>
              <!-- <el-button type="text" size="mini" btnCode="004P002B005"  v-if="btnFlg[5]"  @click="detailsFn(scope.row)">详情</el-button> -->
              <!-- <el-button type="text" size="mini" btnCode="004P002B006"  v-if="btnFlg[6]" v-show="scope.row.auditStatus!=0"  @click="lookSH(scope.row.id)">审批进度</el-button> -->
               <el-button type="text" size="mini" btnCode="004P002B007"  v-if="btnFlg[7]" v-show="scope.row.status==1021||scope.row.status==1031||scope.row.status==1041"     @click="lookPZ(scope.row.id)">查看凭证</el-button>
              </div>
            </template>
        </el-table-column>
         <el-table-column label="转货单号" width="200">
          <template slot-scope="scope">
            <span style="color: #0c46a2;cursor: pointer;" @click="detailsFn(scope.row)">{{scope.row.changeNo}}</span>
          </template>
        </el-table-column>
        <el-table-column width="120" property="status" :formatter="statusFormat" label="转货状态"></el-table-column>
        <el-table-column property="newCustomerName"  width="200" label="新客户名称"></el-table-column>
        <el-table-column property="productNum" label="转货件数"></el-table-column>
        <el-table-column property="allWeight" label="重量(吨)"></el-table-column>
        <el-table-column property="organizationName"  width="240" label="所在仓库"></el-table-column>
        <el-table-column  width="170" :formatter="dateFormat" property="createTime" label="创建时间"></el-table-column>
        <!-- <el-table-column property="newCustomerContacts"  width="160" label="新客户联系人"></el-table-column>
        <el-table-column property="newCustomerPhone"  width="150" label="新客户联系电话"></el-table-column> -->
        <el-table-column  width="170" :formatter="dateFormat" property="completeTime" label="转货完成时间"></el-table-column>
        <el-table-column width="120"  property="remark" :show-overflow-tooltip="true" label="备注信息"></el-table-column>
        <el-table-column  width="170" :formatter="dateFormat" property="confirmingTime" label="仓储退回时间"></el-table-column>
        <el-table-column  width="160" property="confirmingReject" label="仓储退回原因"></el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[25,50,100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 修改 -->
    <el-dialog  title="修改"  :close-on-click-modal="false" :close-on-press-escape="false" class="jiaoyan"  :visible.sync="dialogVisible" width="400px" center>
         <el-form :inline="true" :rules="rules" :model="HTfrom" ref="HTfrom" class="demo-form-inline" label-width="110px" size="mini" border>
        <div class="">
               <el-form-item label="新客户名称:" prop="newCustomer">
                <!-- <el-input  placeholder="" maxlength="40" @blur="xkhmcFn('HTfrom')" v-model="HTfrom.newCustomerName" ></el-input> -->
                 <el-select v-model="HTfrom.newCustomer"  filterable remote placeholder="请输入关键词" allow-create default-first-option
                 :remote-method="xkhmcFn" value-key="custerCode" :loading="loading1">
                  <el-option v-for="item in customerList" :key="item.custerCode" :label="item.custerName" :value="item"> </el-option>
                </el-select>
              </el-form-item>
              <!-- <el-form-item label="新客户联系人:" prop="newCustomerContacts">
                <el-input  placeholder=""  maxlength="10" v-model="HTfrom.newCustomerContacts"></el-input>
              </el-form-item>
              <el-form-item label="新客户联系电话:" prop="newCustomerPhone">
                <el-input  placeholder=""  maxlength="11" v-model="HTfrom.newCustomerPhone"></el-input>
              </el-form-item> -->
              <el-form-item label="备注:" prop="remark">
                <el-input  placeholder=""  maxlength="500" v-model="HTfrom.remark" style="width:215px"></el-input>
              </el-form-item>
        </div>
        </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveFn('HTfrom')">确 定</el-button>
      </span>
    </el-dialog>
     <el-dialog  title="确认密码" append-to-body :close-on-click-modal="false" :close-on-press-escape="false" class="jiaoyan" @close="closeDialog"   :visible.sync="dialogPaw" width="500px" center>
      <span>
         <el-form :inline="true" :rules="rules" :model="pwdFrom" ref="pwdFrom" class="demo-form-inline" label-width="100px" size="mini">
            <el-form-item label="密码:" prop="password">
                  <el-input  placeholder=""  type="password" v-model="pwdFrom.password"></el-input>
                </el-form-item>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogPaw = false">取 消</el-button>
        <el-button type="primary" @click="pwaSaveFn()">确 定</el-button>
      </span>
    </el-dialog>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
// import axios from 'axios'
import { sChangeList, sChangeUpdate, cancelChangeProduct, submitSChange, warehouseList,
  checkPwd, getSChangeFileUrl, getCustomerlistByTenant } from '@/api/soc-stock'
import { encryption } from '@/utils/util'
import { getOrganizationNameList } from '@/api/soc-stock-cosco'
export default {
  data () {
    return {
      getRowKeys (row) {
        return row.id
      },
      dialogVisible: false,
      loading: false,
      dialogSH: false,
      spjd: [],
      h: '500px',
      weight: '0.00',
      takegoodsDialog: false,
      entrustDialog: false,
      tableList: [],
      warehouseList: [],
      total: 0,
      jjfangshi: [
        { val: '', name: '请选择' },
        { val: 1, name: '按吨' },
        { val: 2, name: '包干' }
      ],
      jsfangshi: [
        { val: '', name: '请选择' },
        { val: 1, name: '电汇' },
        { val: 2, name: '现金' },
        { val: 3, name: '其他' }
      ],
      hwly: [
        { val: '', name: '请选择' },
        { val: 1, name: '系统货物' },
        { val: 2, name: '非系统货物' }
      ],
      // tdzt: [
      //   { val: '', name: '请选择' },
      //   { val: 0, name: '待提交' },
      //   { val: 1, name: '已提交' },
      //   { val: 2, name: '已完成' },
      //   { val: 3, name: '已退回' }
      // ],
      szck: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50,
        productType: ''
      },
      pwdFrom: {},
      dialogPaw: false,
      HTfrom: {},
      rules: {
        newCustomer: [
          { required: true, message: '请输入新客户名称', trigger: 'blur' }
        ]
      },
      loading1: false, // 新客户名称下拉
      customerList: [],
      btnFlg: [],
      btnIdArr: ['004P002B000', '004P002B001', '004P002B002',
        '004P002B003', '004P002B004', '004P002B005', '004P002B006', '004P002B007']

    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/transferGoods')
    if (localStorage.getItem('isCutCrm3') == 1) {
      this.warehouseList = [{
        relTenantName: localStorage.getItem('createTenantName'),
        relTenantCode: localStorage.getItem('createTenantCode')
      }]
      this.$set(this.searchFrom, 'organizationId', this.warehouseList[0].relTenantCode)
      this.getList(this.searchFrom)
    } else {
      getOrganizationNameList({
        userCode: localStorage.getItem('userCode'),
        tenantCode: localStorage.getItem('tenantCode')
      }).then(res => {
        this.warehouseList = res
        this.$set(this.searchFrom, 'organizationId', res[0].relTenantCode)
        this.getList(this.searchFrom)
      })
    }

    // warehouseList().then(res => {
    //   selectCommonDictionary({ groupName: 'organizationIds' }).then(res1 => {
    //     if (res1) {
    //       let arr = res.filter(item => item.tenantCode == res1)
    //       this.warehouseList = arr
    //       this.$set(this.searchFrom, 'organizationId', res1)
    //     } else {
    //       this.warehouseList = res
    //     }
    //     this.getList(this.searchFrom)
    //   })
    // })
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 168) + 'px'
  },
  methods: {
    // 查看凭证
    lookPZ (id) {
      let formData = new FormData()
      formData.append('id', id)
      getSChangeFileUrl(formData).then(res => {
        this.$router.push({
          name: 'Pdf',
          query: { path: res }
        })
      })
    },
    // 修改
    modifyFn (row) {
      this.HTfrom = JSON.parse(JSON.stringify(row))
      this.row = row
      this.$set(this.HTfrom, 'newCustomer', row.newCustomerName)
      console.log(this.HTfrom)
      this.dialogVisible = true
    },
    // 根据查询条件获取新客户列表
    xkhmcFn (query) {
      this.loading1 = true
      getCustomerlistByTenant({
        nameLike: this.HTfrom.organizationId,
        custerName: query
      }).then(res => {
        this.loading1 = false
        this.customerList = res
      })
    },
    saveFn (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          if (typeof (this.HTfrom.newCustomer) == 'string') {
            if (this.HTfrom.newCustomer != this.row.newCustomerName) {
              this.HTfrom.newCustomerName = this.HTfrom.newCustomer
              this.HTfrom.newCustomerTaxId = ''
              this.HTfrom.newCustomerId = ''
            }
          } else {
            if (this.HTfrom.newCustomer.custerCode == '') {
              this.HTfrom.newCustomer = null
            } else {
              this.HTfrom.newCustomerTaxId = this.HTfrom.newCustomer.taxpayerNumber
              this.HTfrom.newCustomerId = this.HTfrom.newCustomer.custerCode
              this.HTfrom.newCustomerName = this.HTfrom.newCustomer.custerName
            }
          }
          this.HTfrom.tenantCode = this.HTfrom.organizationId
          sChangeUpdate(this.HTfrom).then(res => {
            loading.close()
            this.$message({
              message: '修改成功',
              type: 'success'
            })
            this.dialogVisible = false
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              duration: 0,
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    // 删除
    recallFn (row) {
      this.$confirm('是否执行删除操作?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        cancelChangeProduct({ id: row.id }).then(res => {
          loading.close()
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 详情
    detailsFn (row) {
      this.$router.push({ name: 'transferDetails', query: { id: row.id } })
    },

    // 提交
    submitFn (row) {
      this.$confirm('是否执行提交操作?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        submitSChange({ id: row.id }).then(res => {
          loading.close()
          this.$message({
            message: '提交成功',
            type: 'success'
          })
          this.dialogPaw = false
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            duration: 0,
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    pwaSaveFn () {
      let data = encryption({
        data: this.pwdFrom,
        key: this.global.key,
        param: ['password']
      })
      this.$refs.pwdFrom.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          checkPwd(data).then(res => {
            submitSChange({ id: this.id }).then(res => {
              loading.close()
              this.$message({
                message: '提交成功',
                type: 'success'
              })
              this.dialogPaw = false
              this.getList(this.searchFrom)
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                duration: 0,
                onClose () {
                  loading.close()
                }
              })
            })
          // eslint-disable-next-line handle-callback-err
          }).catch(error => {
            this.$message({
              showClose: true,
              message: '验证密码失败',
              type: 'error',
              duration: 0,
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    // 查选
    searchFn () {
      if (this.searchFrom.cargoBarcodes) { this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcodes.split(/[(\r\n)\r\n]+/) }

      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {
      this.weight = 0
      var that = this
      selection.forEach(item => {
        that.weight = (that.weight * 1000 + item.weight * 1000) / 1000
      })
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取货物列表
    getList (searchFrom) {
      sChangeList(searchFrom).then(res => {
        console.log(res)
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    closeDialog () {
      if (this.$refs.HQform !== undefined) {
        this.$refs.HQform.resetFields()
      }
      if (this.$refs.THform !== undefined) {
        this.$refs.THform.resetFields()
      }
      if (this.$refs.PHform !== undefined) {
        this.$refs.PHform.resetFields()
      }
      this.$refs.table.clearSelection()
      this.pwdFrom = {}
    },
    // 重置
    resetForm (formName) {
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        completeTime: null,
        createTime: null
      }
      this.$set(this.searchFrom, 'organizationId', this.warehouseList[0].relTenantCode)
    },
    // 状态格式化
    statusFormat (row, column, cellValue) {
      switch (cellValue) {
        case 1001:
          return '待提交'
        case 1011:
          return '审批中'
        case 1012:
          return '审批驳回'
        case 1021:
          return '转货中'
        case 1031:
          return '已完成'
        case 1041:
          return '己退回'
      }
    },
    // 时间格式化
    dateFormat: function (row, column, cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
    t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
      var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
      var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
      var str = ''
      if (cellValue == null) {
        str = ''
      } else {
        str = t.getFullYear() + '-' + month + '-' + date + ' ' + hour + ':' + minutes + ':' + seconds
      }
      return str
      // return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate(); // 年月日
    }
  }
}
</script>

<style scoped lang='less'>
.searchBox{
  display: flex;
}
.inpBox .el-date-editor{
      width: 350px!important;
}
.gjhBox{
      flex-shrink: 0;
}
.gjhBox /deep/.el-textarea__inner{
  width:150px;
}

/deep/.el-input.is-disabled .el-input__inner{
    border: none;
    background-color: #dcedff;
    color: #606266;
}
.dialogtnBox{
  display: flex;
  justify-content: space-between;
  /deep/.el-form-item--mini.el-form-item{
        margin-bottom: 15px!important;
  }

}
 .formItemBox{
    /deep/.el-form-item{
      width: 24%;
    }
  }
</style>
